import React, { useEffect, useState } from 'react';
import InvitUser from "./Components/InvitUser";
import CreateOrganisme from "./Components/CreateOrganisme";
import Access from "./Components/Access";
import Navbar from "./Components/Navbar";
import NavbarAdmin from "./Components/NavbarAdmin";
import SwitchOrganisme from "./Components/SwitchOrganisme";
import SiphonnageDataOrg from './Components/SiphonnageDataOrg';
import CreateBudget from "./Components/CreateBudget";
import DeleteOrganisme from "./Components/DeleteOrganisme";
import SetupYearsApplication from "./Components/SetupYearsApplication";
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import qs from 'qs';
import { get } from 'react-hook-form';


const Adminpage = (props) =>
{
    let history = useHistory();
    const [organismes, setOrganismes] = useState([]);
    const [type_users, setType_users] = useState([]);
    const [organismes_type, setOrganismes_type] = useState([]);

    const purple = '#6571FE';

    function getdatas()
    {
        if (props.user)
        {
            var params = {
                'getDatas': true
            }
            axios.post("https://app-slfinance.fr/api/admin_page.php", qs.stringify(params))
            .then((r) => {
                setOrganismes(r.data.organismes);
                setType_users(r.data.users_type);
                setOrganismes_type(r.data.organismes_type);
            })
            .catch((err) => {
                console.warn(err)
            })
        }
    }

    useEffect(() => {
        if (!props.user)
        {
            props.getUser();
        }
        else {
            getdatas();
        }
    }, [props.user])


    function tout_faire()
    {
        const params = {
            'tests': true,
        }
        
        axios.post("https://app-slfinance.fr/api/tests.php", qs.stringify(params))
        .then((r) => {
            console.log(r.data)
        })
        .catch((err) => {
            console.warn(err)
        })
    }


	return (
        <Access needConnection={true} type_user={[1]}>
            <Navbar />
            <NavbarAdmin />
            <div style={{display: 'flex'}}>
                <div style={{flex: 1}}>
                    <div style={{display: 'flex'}}>

                        <div style={{flex: 1, textAlign: 'center'}}>
                            <div style={{margin: 20}}>
                                <SwitchOrganisme user={props.user} getUser={props.getUser} organismes={organismes}/>
                            </div>
                            <div style={{flex: 1, margin: 20}}>
                                <InvitUser user={props.user ? props.user:null} organismes={organismes} type_users={type_users}/>
                            </div>

                            {props.user && props.user.email === 'victor.castera@strategies-locales.fr'?
                            <div>
                                <div style={{margin: 20}}>
                                    <button className='shadow-md p-2 rounded-md' style={{backgroundColor: purple, color: 'white', fontSize: 14, fontSize: 14}}
                                    onClick={() => {tout_faire()}}>Le bouton à tout faire
                                    </button>
                                </div>
                            </div>
                            :null}
                        </div>


                        <div style={{flex: 1}}>
                            <div style={{margin: 20}}>
                                <CreateOrganisme organismes_type={organismes_type} />
                            </div>
                            <div style={{margin: 20}}>
                                <CreateBudget organismes={organismes} />
                            </div>
                        </div>


                        <div style={{flex: 1, textAlign: 'center'}}>
                            <div style={{margin: 20, border: '2px solid orange', borderRadius: 5}}>
                                <SiphonnageDataOrg user={props.user} getUser={props.getUser} organismes={organismes} />
                            </div>
                            <div style={{margin: 20, border: '2px solid red', borderRadius: 5}}>
                                <DeleteOrganisme organismes={organismes} />
                            </div>
                            <div style={{flex: 1, margin: 20, border: '2px solid orange', borderRadius: 5}}>
                                <SetupYearsApplication />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </Access>
	);
}

export default Adminpage;
